<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <div class="modal-card-title">Email to {{ Group.Name }} Group Users</div>
    </div>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column is-half">
          <p>From: CTC.compliance.index@awg.aero</p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-1">
          <p>To:</p>
        </div>
        <div class="column is-5">
          <p v-for="user in ToCollection">{{ user.Name }}</p>
          <span>
            <a @click="openAddUserModal({})">Add User</a>
          </span>
        </div>
        <div class="column is-1">
          <p>CC:</p>
        </div>
        <div class="column is-5">
          <div v-for="current in CC" v-bind:key="current.Name">
            <b-checkbox v-model="ccSelection" :native-value="current.Email">{{ current.Name }}</b-checkbox>
          </div>
        </div>
      </div>
      <b-field label="Subject">
        <b-input type="text" placeholder="Subject" v-model="email.Subject"></b-input>
      </b-field>
      <br />
      <b-field label="Message">
        <editor apiKey="0qgi7f55b2ue7vvn7vvi7w9zim05110j4aznns846hbq588x"
                v-model="email.Message"
                :init="{
                    menubar: false,
                    plugins: [
                    'autoresize',
                    'wordcount'
                    ],
                    toolbar:
                    'formatselect | bold italic underline | \
                    bullist numlist outdent indent | removeformat | spellchecker',
                    browser_spellcheck: true
            }"></editor>
      </b-field>
    </div>
    <div class="modal-card-foot">
      <b-button @click="$parent.close()">Cancel</b-button>
      <b-button class="is-primary" @click="sendEmail">Send Email</b-button>
    </div>
  </div>
</template>

<script>
  import addUser from '@/components/modals/addUser.vue';
  import Editor from '@tinymce/tinymce-vue';
  export default {
    components: {
      'editor': Editor
    },
    data() {
      return {
        email: {},
        ccSelection: [],
        ToAdditions: []
      }
    },
    props: {
      To: Array,
      CC: Array,
      Group: Object
    },
    computed: {
      ToCollection() {
        return this.To.concat(this.ToAdditions);
      }
    },
    methods: {
      sendEmail() {
        if (this.email.Message) {
          this.email.To = [];
          this.ToCollection.forEach(to => {
            this.email.To.push(to.Email);
          });

          this.email.CC = this.ccSelection;
          this.$emit('sendGroupEmail', this.email);
          this.$parent.close();
        } else {
          this.$buefy.notification.open({
            duration: 4000,
            message: "Please enter a message.",
            type: 'is-danger',
          })
        }
      },
      openAddUserModal(model) {
        var self = this;
        this.$buefy.modal.open({
          parent: this,
          component: addUser,
          hasModalCard: true,
          props: {
            Model: model,
            Group: this.Group
          },
          events: {
            refreshUsers: (user) => {
              self.ToAdditions.push(user)
            }
          }
        })
      }

    }
  }
</script>
